<template>
    <nav class="extra">
      <div class="extra-title" :class="{'extra-title-collapsed': visible === false}" @click.stop="toggle">
        <transition name="fade" mode="out-in">
          <h1>
            <span>Extra Content</span>
          </h1>
        </transition>
      </div>
      <div class="extra-tray" ref="extraTray" :class="{'extra-tray-visible': visible === true}" @scroll="onScroll">
        <div class="extra-tray-header">
          <div class="extra-tray-header-left">
            EXTRA
          </div>
          <div class="extra-tray-header-center">
            <span style="transition: opacity 0.5s;" :style="{'opacity': this.currentTitle == '' ? 0 : 1}" v-html="currentTitle"/>
          </div>
          <div class="extra-tray-header-right">
            <a @click="toggle">✕&nbsp;<span>{{$root.t('menu_close')}}</span></a>
          </div>
        </div>

        <div class="extra-tray-title">
          <div class="extra-marker" ref="extraTitle"><span>{{ meta.Options.InsideTitle }}</span></div>
          <h1>
            <span v-if="meta.Options.InsideTitle" v-html="meta.Options.InsideTitle"/>
            <!--<span v-if="meta.Options.Subtitle" v-html="meta.Options.Subtitle"/>-->
            <!--<span v-if="meta.Options.Author" v-html="`<br>${meta.Options.Author}`"/>-->
          </h1>
        </div>

        <template v-for="(item, key) in extra">
          <template>
            <div :class="`extra-scrollmarker sort-${item._writerChapterSort} ${item._writerTitle && (key==0 || item._writerTitle != extra[key - 1]._writerTitle) ? 'extra-scrollmarker-sticky' : 'extra-scrollmarker-offset'} `" :ref="`content-${item._id}`" :key="`content-${item._id}`"/>
            <div class="extra-tray-box extra-tray-box-header" v-if="item._writerTitle && (key==0 || item._writerTitle != extra[key - 1]._writerTitle) " :key="`title-${item._id}`">
              <div class="extra-tray-box-header-left" v-html="item._writerAuthor"/>
              <div class="extra-tray-box-header-center" v-html="item._writerHeader"/>
            </div>
            <div class="extra-tray-box extra-tray-box-dimmed" :key="`box-${item._id}`">
              <div class="extra-marker"><span>{{ item._writerHeader ? item._writerHeader : meta.Options.InsideTitle }}</span></div>
              <div class="extra-tray-box-content extra-element">
                <div class="extra-element-cols">
                  <div class="extra-element-left" v-html="item.LeftCol"/>
                  <div class="extra-element-center">
                    <div v-if="item.Title" class="extra-element-lead" v-html="item.Title"/>
                  </div>
                  <div class="extra-element-right" v-html="item.RightCol"/>
                </div>
                <!-- Body -->
                <div class="extra-element-reader" v-if="item.Text || item.Bibliography">
                  <div :class="{'extra-element-text-collapsed': item.Text.length > 2500 && !toggled[item._id], 'extra-element-text-space': item.Text && item.Text.length > 2500}" class="extra-element-text">
                    <div v-html="item.Text" @click="interaction"/>
                    <div v-if="item.Bibliography" class="extra-element-text-label" v-html="item.Bibliography" @click="interaction"/>
                  </div>
                  <div v-if="item.Text && item.Text.length > 2500" class="extra-element-text extra-more" :class="{'extra-more-sticky': toggled[item._id]}">
                    <div class="extra-more-button" @click="toggleItem(item._id)">{{toggled[item._id] ? $root.t('menu_collapse') : $root.t('menu_toggle')}}</div>
                  </div>
                </div>
                <!-- Additional Items -->
                <div v-if="item.Images && item.Images.length > 0 && item.GalleryType && item.GalleryType.length > 0 && item.GalleryType.indexOf('Default') != -1 " class="extra-element-images-default">
                  <GalleryDefault :images="item.Images"/>
                </div>
                <div v-if="item.Images && item.Images.length > 0 && item.GalleryType && item.GalleryType.length > 0 && item.GalleryType.indexOf('Archive') != -1 " class="extra-element-images-default">
                  <GalleryArchive :images="item.Images"/>
                </div>
                <div v-if="item.Downloads && item.Downloads.length > 0" class="extra-element-file">
                  <Filedownload :downloads="item.Downloads"/>
                </div>
                <template v-if="item.Audio && item.Audio.length > 0">
                  <div v-for="audio in item.Audio" class="extra-element-av" :key="audio.Original">
                    <Audioplayer :caption="audio.Captions[0]" :src="audio.Original"/>
                  </div>
                </template>
                <template v-if="item.Video && item.Video.length > 0">
                  <div v-for="(video, vk) in item.Video" class="extra-element-av" :key="video.Original">
                    <Videoplayer :caption="video.Captions[0]" :poster="item.VideoPoster && item.VideoPoster[vk] && item.VideoPoster[vk].Resized ? item.VideoPoster[vk].Resized[0] : null" :src="video.Original"/>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </template>
      </div>
    </nav>
</template>

<script>

import Audioplayer from './Audioplayer.vue'
import Videoplayer from './Videoplayer.vue'
import Filedownload from './Filedownload.vue'
import GalleryDefault from './GalleryDefault.vue'
import GalleryArchive from './GalleryArchive.vue'
import { scroller } from 'vue-scrollto/src/scrollTo'

export default {
  name: 'Extra',
  components: {
    Audioplayer,
    Videoplayer,
    Filedownload,
    GalleryDefault,
    GalleryArchive
  },
  data () {
    return ({
      visible: false,
      scrollTo: scroller(),
      params: {bookId: this.$route.params.bookId},
      extra: this.book.extra,
      meta: this.book.meta,
      currentTitle: '',
      toggled: [],
      toggledHeight: 0
    })
  },
  props: [
    'book'
  ],
  async mounted () {
    console.log(`📕 Loading Extra`, this.extra)
    this.extraOpenedListener = (e) => {
      this.visible = this.$root.overlay = e.visible
      this.filter(e)
    }
    this.$root.$on('extra-opened', this.extraOpenedListener)
  },
  beforeDestroy () {
    console.log('destroy extra')
    this.$root.$off('extra-opened', this.extraOpenedListener)
  },
  methods: {
    onScroll (e) {
      if (e.target.scrollTop > window.innerHeight / 2) {
        this.currentTitle = this.meta.Options.InsideTitle
      } else {
        this.currentTitle = ''
      }
    },
    interaction (event) {
      if (event.target.nodeName === 'A') {
        event.preventDefault()
        event.stopPropagation()
        const url = event.target.getAttribute('href')
        window.open(url, '_blank')
        return false
      }
    },
    toggleItem (id) {
      const extraTray = this.$refs.extraTray
      if (!this.toggled[id]) {
        this.toggledHeight = extraTray.pageYOffset || extraTray.scrollTop
      }
      this.$set(this.toggled, id, !this.toggled[id])
      this.$nextTick(() => {
        if (!this.toggled[id] && this.toggledHeight !== null) {
          extraTray.scrollTo({
            top: this.toggledHeight,
            behavior: 'smooth'
          })
          this.toggledHeight = null
        }
      })
    },
    toTop () {
      const extraTray = this.$refs.extraTray
      if (extraTray) {
        extraTray.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    toElement (e) {
      const extraTray = this.$refs.extraTray
      if (extraTray) {
        console.log('scrolling')
        this.scrollTo(e, 250, {
          container: extraTray,
          x: false,
          y: true,
          offset: 0,
          cancelable: false
        })
      }
    },
    filter (params) {
      this.params = params || this.params || {bookId: this.$route.params.bookId} // {bookId: "130", extraChapter: "1", extraItem: "66"}
      console.log(`📕 Filtering Extra`, this.params)
      this.$nextTick(() => {
        let e
        if (this.params.extraItem) {
          e = this.$refs[`content-${this.params.extraItem}`]
        } else if (this.params.extraChapter) {
          e = document.getElementsByClassName(`sort-${+this.params.extraChapter}`)
        }
        if (e && e.length > 0) {
          setTimeout(() => { this.toElement(e[0]) }, 500)
        }
      })
    },
    toggle () {
      if (this.visible) {
        if (this.$router.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.push({name: 'book',
            params: {...this.$route.params,
              extraBook: undefined,
              extraChapter: undefined,
              extraItem: undefined
            }})
        }
      } else {
        this.$router.push({name: 'book', params: {...this.$route.params, extraBook: 'extra'}})
      }
    }
  }
}
</script>

<style lang="scss">

@import '../main';
.extra {
  --extra-background: rgb(0, 0, 0);
  --line-color: #606060;
  --extra-dimmed-background-rgb: 32, 32, 32;
  --extra-dimmed-background: rgb(var(--extra-dimmed-background-rgb));
  color: white;
  right: 0px;
  pointer-events: none;
  z-index: 2001;
  font-weight: normal;
  letter-spacing: normal;

  @include sm() {
    z-index: 299;
  }
  &-scrollmarker {
    position: absolute;
    width: 10px;
    height: var(--menuwidth-hidden);
    visibility: hidden;
    &-sticky {
      margin-top: var(--padding);
    }
    &-offset {
      margin-top: calc(-1 * var(--menuwidth-hidden));
    }
  }
  &-more {
    text-align: center;
    &-sticky {
      position: sticky !important;
      bottom: 0px;
      .extra-more-button {
        background: rgba(var(--extra-dimmed-background-rgb), 0.9);
      }
    }
  }
  &-more-button {
    border: 1px solid;
    display: inline-flex;
    height: var(--menuwidth-hidden);
    justify-content: center;
    align-items: center;
    line-height: 0 !important;
    padding: 0 var(--padding-05);
    cursor: pointer;
    transition: var(--button-anim);
    @include tocfooterfont();
    @include hover() {
      background: white;
      color: black;
      border-color: white;
    }
  }
  &-marker {
    position: sticky;
    top: var(--menuwidth-hidden);
    height: 0px;
    width: 0px;
    span {
      display: none;
    }
  }
  &-element {
    h1, h2, h3, h4 {
      &:first-child {
        padding-top: 0 !important;
      }
    }
    &-cols {
      display: flex;
    }
    &-left,
    &-right {
      box-sizing: border-box;
      a {
        word-break: break-all;
      }
      flex-grow:1;
      flex-basis: 50%;
    }
    &-left {
      padding-right: var(--padding);
      margin-top: -3px;
    }
    &-right {
      @include smallfont;
      padding-left: var(--padding);
      blockquote {
        margin: 0;
        p {
          margin: 0;
          padding: 0;
          padding-left: var(--padding-15);
          text-indent: calc(-1 * var(--padding-15));
        }
      }
    }
    &-center {
      width: var(--paperwidth);
      flex-shrink: 0;
      margin-top: -9px;
    }

    @include sd() {
      &-cols {
        flex-direction: column;
      }
      &-left, &-right, &-center {
        width: 100%;
        padding: 0;
        margin: auto;
        max-width: var(--paperwidth);
        margin-bottom: var(--padding);
      }
      &-left {
        order: 0;
      }
      &-right {
        order: 3;
      }
    }
    &-lead {
      @include largeextrafont();
    }
    &-text {
      position: relative;
      &-collapsed {
        max-height: 80vh;
        max-height: 80svh;
        overflow: hidden;
        &:after {
          position: absolute;
          content: "";
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 15vh;
          height: 15lvh;
          background: linear-gradient(rgba(0,0,0,0),var(--extra-dimmed-background) 90%);
          box-sizing: border-box;
        }
      }
      &-space {
        margin-bottom: var(--menuwidth-hidden)
      }
      &-label {
        @include smallfont;
        blockquote {
          margin: 0;
          p {
            margin: 0;
            padding: 0;
            padding-left: var(--padding-15);
            text-indent: calc(-1 * var(--padding-15));
          }
        }
      }

      .rf-parsed {
        margin: 0;
        margin-bottom: var(--padding-20);
        margin-top: var(--padding);
        display: flex;
        justify-content: left;
        .rf-container {
          display: table;
        }
        img {
          display: none;
          max-height: 66vh;
          max-height: 66svh;
        }
        .scaled_2 {
          display: table-row;
          max-width: 100%;
          height: auto;
        }
        figcaption {
          display: table-caption;
          caption-side: bottom;
          @include smallfont;
          margin-top: var(--padding-05);
          margin-bottom: var(--padding);
        }
      }

    }
    &-reader,
    &-av {
      max-width: var(--paperwidth);
      width: 100%;
      margin: auto;
    }
    &-file {
      max-width: var(--paperwidth);
      width: 100%;
      margin: auto;
    }
    &-images {
      &-default {
        clear: both;
      }
    }
    & > *:not(:first-child) {
      margin-top: var(--padding);
    }
    ul {
      margin: 0;
      margin-bottom: var(--padding);
      list-style: none;
      padding-left: 0;
      li {
        text-indent: calc(-1 * var(--padding));
        padding-left: var(--padding);
        &:before {
          content: "–";
          float: left;
          width: var(--padding);
        }
      }
    }
  }
  &-tray {
    pointer-events: all;
    background: var(--extra-background);
    width: calc(100vw - var(--menuwidth-hidden));
    padding-right: var(--menuwidth-hidden);
    padding-top: 0 !important;
    right: 0px;
    transform: translateX(100%);
    &-box {
      margin-right: calc(0.5 * var(--menuwidth-hidden));
      margin-left: calc(0.5 * var(--menuwidth-hidden));

      @include sm() {
        margin-left: var(--padding-05);
        margin-right: var(--padding-05);
      }
      box-sizing: border-box;
      margin-top: 2px;
      &-header {
        text-transform: uppercase;
        @include headerfont;
        @include flex-vertical-center;
        position: sticky;
        top: 0px;
        z-index: 1000;
        height: var(--menuwidth-hidden);
        background: var(--extra-background);
        margin-bottom: var(--padding);
        margin-top: var(--padding);
        width: calc(100% - 130px);
        @include sm() {
          width: calc(100% - 40px);
        }
        & > div {
          white-space: nowrap;
          overflow: hidden;
        }
        &-left {
          width: calc((100vw - var(--paperwidth) - 4 * var(--menuwidth-hidden)) / 2);
          @include sd() {
            display: none !important;
          }
          flex-shrink: 0;
        }
        &-center {
          flex-grow: 1;
          flex-shrink: 1;
          width: auto;
          text-overflow: ellipsis;
        }
      }
      &-content {
        margin: auto;
        &-small {
          max-width: var(--paperwidth);
        }
        pre {
          @include smallfont;
          white-space: pre-wrap;
        }
      }
      &-dimmed {
        background: var(--extra-dimmed-background);
        padding: calc(0.5 * var(--menuwidth-hidden));
        border-radius: 2px;
      }
    }
    &-header {
        & + .extra-tray-box{
          border-top: none;
        }
        position: sticky;
        z-index: 100;
        top: 0px;
        left: 0px;
        height: var(--menuwidth-hidden);
        right: 0px;
        text-transform: uppercase;
        @include headerfont;
        @include flex-vertical-center;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 calc( 0.5 * var(--menuwidth-hidden));
        background: var(--extra-background);
        @include sm() {
          padding: 0;
        }
        a {
          cursor: pointer;
        }
        &-left, &-right, &-center {
          @include flex-vertical-center;
          overflow: hidden;
          box-sizing: border-box;
          white-space: nowrap;
          width: 100%;
          * {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            br {
              display: none;
            }
          }
        }
        &-left {
          justify-content: flex-start;
          & > a {
            display: inline-block;
          }
        }
        &-right {
          justify-content: flex-end;
          text-align: right;
          & > a {
            text-align: right;
          }
          @include sm() {
            transform: scale(180%);
            span {
              display: none !important;
            }
          }
        }
        &-center {
          flex-basis: var(--paperwidth);
          justify-content: space-between;
          flex-direction: row;
          box-sizing: border-box;
          @include sd() {
           flex-basis: auto;
           width: auto;
           flex-grow: 1;
          }
          @include sm() {
            display: none;
          }
        }
        &-left, &-right {
          flex-basis: calc(((100vw - var(--paperwidth)) / 2) - var(--total-menuwidth));
          padding: 0;
          @include sd() {
           flex-basis: auto;
           width: auto;
           flex-shrink: 0;
          }
          @include sm() {
           padding: 0 var(--padding-05);
          }
        }
        &-left {
          @include sd() {
           padding-right: var(--padding);
          }
        }
    }
    &-title {
      h1 {
        text-transform: uppercase;
        position: relative;
        @include chapterfont;
        font-weight: 600;
        @include svh(20, 'padding-bottom');
        @include svh(20, 'padding-top');
        @include sm() {
          padding: var(--padding-30) 0;
        }
        span {
          display: block
        }
        br {
          display: none;
        }
      }
    }
  }
  &-title {
    pointer-events: all;
    right: 0px;
    background: var(--extra-background);
    h1 {
      text-transform: uppercase;
    }
    transition: var(--nav-hoover-anim);
    &-collapsed {
      @include hover() {
        transform: translateX(0);
      }
    }
    @include sm() {
      top: auto;
      @include lvh(50, 'height', '!important');
      bottom: 0px !important;
      top: auto !important;
    }
  }
}
/*@include sm() {
  .app-context-active {
    .extra {
      transform: translateX(100%);
    }
  }
}*/
</style>



// WEBPACK FOOTER //
// src/components/Extra.vue